<template>
  <v-container :class="'ma-0 pa-0 '" fluid>
    <v-row class='pa-0 ma-0' align='start'>
      <v-col cols='4'>
        <v-card>
          <v-card-title>
            <div>{{ $t('referenceBooks.roles.Roles') }}</div>
            <v-divider class='mx-4' inset vertical> </v-divider>

            <RoleDialog :mode='0' v-on:created='onCreated' />
            <RoleDialog
              v-if='selectedRole.length === 1'
              :mode='1'
              :role='selectedRole[0]'
              v-on:saved='onSaved'
            />
            <Confirm
              v-if='selectedRole.length === 1'
              :text='$t("referenceBooks.roles.Delete")'
              :title='
                $t("referenceBooks.roles.DeleteRoleWithName", [
                  selectedRole[0].description,
                ]) + "?"
              '
              v-on:ok='onDeleteRole'
              :icon-name='"mdi-close"'
              :tooltipText='$t("referenceBooks.roles.Delete")'
            />
            <v-spacer />
            <span class='subtitle-2'
              >{{ $t('cards.total') }}:{{ roles.length }}</span
            >
          </v-card-title>
          <LightTable
            :headers='rolesHeaders'
            :items='roles'
            itemKey='roleId'
            sort-by='description'
            must-sort
            :needCustomSort='false'
            :selectedItems='selectedRole'
            :markedItems='changedRolesId'
            v-on:update='onUpdate'
            singleSelect
          />
        </v-card>
      </v-col>

      <v-col cols='8' md='8'>
        <v-card>
          <v-card-title>
            <div>{{ $t('referenceBooks.roles.Rights') }}</div>
            <v-divider class='mx-4' inset vertical> </v-divider>
            <v-switch
              class='pa-0 ma-0'
              v-model='rightsMode'
              :label='$t("Edit")'
            ></v-switch>
            <v-spacer />

            <v-tooltip v-if='isEditModeEnabled'>
              <template v-slot:activator='{ on: tooltip }'>
                <v-btn
                  class='mr-1'
                  small
                  dark
                  color='primary'
                  @click='saveRoleRightsChanges'
                  v-on='{ ...tooltip, ...dialog }'
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('Save') }}</span>
            </v-tooltip>

            <v-spacer></v-spacer>
            <span class='subtitle-2'
              >{{ $t('cards.total') }}:{{ rights.length }}</span
            >
          </v-card-title>
          <v-data-table
            :selectable-key='"rightId"'
            v-model='selectedRights'
            :headers='rightsHeaders'
            :items='rights'
            :item-key='"rightId"'
            class='elevation-3'
            :single-select='rightsSingleSelect'
            disable-pagination
            sort-by='rightName'
            must-sort
            :show-select='isEditModeEnabled'
            hide-default-footer
            :height='tableHeight'
          >
            <template v-slot:item.rightName='props'>
              {{ $t('rightsNames.rightName' + props.item.rightId) }}
            </template>
            <template v-slot:item.domainName='props'>
              <v-radio-group v-model='props.item.domainId' row>
                <v-radio
                  :disabled='!isEditModeEnabled'
                  :color='"black"'
                  v-for='d in props.item.domains'
                  :key='d.domainId'
                  :label='$t("domainsNames.domainName" + d.domainId)'
                  :value='d.domainId'
                ></v-radio>
              </v-radio-group>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Confirm from '@/components/Confirm';
import RoleDialog from '@/components/Dialogs/RoleDialog';
import { notifyError, notifySuccess } from '@/services/notifications';
import LightTable from '@/components/Tables/LightTable';
import tableHeightMixin from './mixins/tableHeightMixin';

export default {
  name: 'Roles',
  components: { RoleDialog, Confirm, LightTable },
  mixins: [tableHeightMixin],
  data() {
    return {
      changedRolesId: [],
      rightsMode: false,
      selectedDomainId: 0,
      tree: [],

      dialog: false,

      roles: [],
      selectedRole: [],

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 48,
      filterH: 12,
      tHeaderH: 64,
      tFooterH: 60,

      rolesSingleSelect: true,

      rights: [],
      selectedRights: [],
      rightsSingleSelect: false,
      scaleValue1: '',
    };
  },
  computed: {
    rolesHeaders() {
      return [
        { text: '', value: '0', sortable: false },
        {
          text: this.$t('referenceBooks.roles.RoleName'),
          value: 'description',
          sortable: true,
        },
      ];
    },
    rightsHeaders() {
      return [
        { text: '', value: '0', sortable: false },
        {
          text: this.$t('referenceBooks.roles.RightName'),
          value: 'rightName',
          sortable: true,
          width: '200px',
        },
        {
          text: this.$t('referenceBooks.roles.Domain'),
          value: 'domainName',
          sortable: false,
        },
      ];
    },

    isViewModeEnabled() {
      return !this.rightsMode;
    },
    isEditModeEnabled() {
      return this.rightsMode;
    },
    apiUri() {
      return this.$store.state.apiUri;
    },
    changedSelectedRights() {
      return this.rights.filter((right) =>
        this.selectedRights.some((sr) => sr.rightId === right.rightId)
      );
    },
  },
  watch: {
    selectedRole(val) {
      this.rights = [];
      this.loadRights(val[0]);
    },
    rightsMode() {
      this.loadRights(this.selectedRole[0]);
    },
    selectedRights(val) {
      val.forEach((selectedRight) => {
        if (
          this.rights.filter((right) => right.rightId === selectedRight.rightId)
            .length === 1
        ) {
          const index = this.rights.indexOf(
            this.rights.filter(
              (right) => right.rightId === selectedRight.rightId
            )[0]
          );

          this.rights[index].domainId = selectedRight.domainId;
          this.rights[index].domainName = selectedRight.domainName;
        }
      });
    },
  },
  async mounted() {
    await this.loadRoles();
  },
  beforeDestroy() {
    this.$eventBus.$off('scaleValueChanged');
  },
  created() {
    this.$eventBus.$on(
      'scaleValueChanged',
      () => (this.scaleValue1 = this.$localStorageObj.getScaleByUser(''))
    );
  },
  methods: {
    onUpdate(items) {
      this.selectedRole = items;
      this.changedRolesId = [];
    },
    markRow(roleId) {
      this.changedRolesId = [];
      this.changedRolesId.push(roleId);
    },
    async onDeleteRole() {
      const role = this.selectedRole[0];
      await this.$axios.roles
        .delete(role.roleId)
        .then(() => {
          this.rights = [];
          this.selectedRights = [];
          notifySuccess(
            '',
            this.$t('Messages.RoleWasDeleted', [role.description])
          );
        })
        .catch((error) => {
          console.error(error);

          if (
            error.response.data.errorType &&
            error.response.data.errorType === 'HAS_RELATIONS'
          ) {
            notifyError('', this.$t('errorsMessages.RoleIsAttachedToUsers'));
          } else notifyError('', this.$t('Error'));
        });
      await this.loadRoles();
    },
    onCreated(roleId) {
      this.selectedRole = [];
      this.loadRoles();
      this.markRow(roleId);
    },
    onSaved(roleId) {
      this.selectedRole = [];
      this.loadRoles();
      this.markRow(roleId);
    },

    saveDomain(item, domainId) {
      const domain = item.domains.filter((d) => d.domainId === domainId)[0];
      item.domainId = domain.domainId;
      item.domainName = domain.domainName;
    },
    roleSelected(item) {
      if (!item.value) this.selectedRights = [];
    },

    async loadRoles() {
      await this.$axios.roles
        .get()
        .then((response) => response.data)
        .then((json) => {
          this.roles = json;
        })
        .catch((e) => {
          console.error(e);
        });
    },
    async loadRights(role) {
      this.selectedRights = [];

      await this.$axios.rights
        .get()
        .then((response) => response.data)
        .then((json) => {
          this.rights = json;
        })
        .catch((e) => {
          console.error(e);
        });

      await this.$axios.rights
        .getByRoleId(role.roleId)
        .then((response) => response.data)
        .then((json) => {
          this.selectedRights = json;

          if (this.isViewModeEnabled) {
            this.rights = this.rights.filter((r) =>
              this.selectedRights.some((sr) => sr.rightId === r.rightId)
            );
          }
        })
        .catch((e) => {
          console.error(e);
        });

      this.selectedRights.forEach((selectedRight) => {
        if (
          this.rights.filter((right) => right.rightId === selectedRight.rightId)
            .length === 1
        ) {
          const index = this.rights.indexOf(
            this.rights.filter(
              (right) => right.rightId === selectedRight.rightId
            )[0]
          );
          this.rights[index].domainId = selectedRight.domainId;
          this.rights[index].domainName = selectedRight.domainName;
        }

        if (this.isViewModeEnabled) {
          this.selectedRights = [];
        }
      });
    },

    async saveRoleRightsChanges() {
      const data = this.changedSelectedRights.map((sr) => {
        return { rightId: sr.rightId, domainId: sr.domainId };
      });

      await this.$axios.rights
        .setRightsForRoleId(this.selectedRole[0].roleId, data)
        .then(() => {
          this.loadRights(this.selectedRole[0]);
          notifySuccess(
            '',
            this.$t('Messages.RightsWereAttachedToRole', [
              this.selectedRole[0].description,
            ])
          );
        })
        .catch((error) => {
          console.error(error);

          if (error.response.data.errorType === 'HAS_RELATIONS') {
            notifyError('', this.$t('errorsMessages.RoleIsAttachedToUsers'));
          } else notifyError('', this.$t('Error'));
        });
    },
  },
};
</script>
